var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTranslateThin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2759_4632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 12.5L21 20M30 21.5L21 12.5L18 8M33 8H15M25.5 3.5H24M16.6305 26H5.8695M16.6305 26L19.5 32M16.6305 26L12.3326 17.0135C11.9862 16.2894 11.8131 15.9274 11.5761 15.8129C11.3702 15.7135 11.1299 15.7135 10.9239 15.8129C10.6869 15.9274 10.5138 16.2894 10.1675 17.0135L5.8695 26M5.8695 26L3 32",
    stroke: "url(#paint0_linear_2759_4632)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2759_4632",
    x1: 33.25,
    y1: 18,
    x2: 18.8507,
    y2: 3.01203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7030A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#D96380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF934E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2759_4632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "matrix(-1 0 0 1 36 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateThin);
export default __webpack_public_path__ + "static/media/translate-thin.7290c9bf79b07c3ccc8393b7f6241e4f.svg";
export { ForwardRef as ReactComponent };